
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toolkits",
      function () {
        return require("private-next-pages/toolkits/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toolkits"])
      });
    }
  